module.exports = __webpack_public_path__ + "img/business-6.70e3869d.png";